import * as React from "react";
import * as ReactDOM from "react-dom";
import * as _ from "lodash";
import {connect} from "react-redux";
import { IYear} from "../../../../data/data";
import {endYear} from "../../../../store/actions/calendar/year";
import {getTime, getYearDuration, isTimerRunning} from "../../../../store/reducers/timer";
import {tickTimer} from "../../../../store/actions/timer";
import {MONTHS} from './months';
import {getYearData} from '../../../../store/reducers/year';
import Calendar from '../../../common/calendar/Calendar';

interface Props
{
    year: IYear;
    time: number;
    duration: number;
    timer_is_running: boolean;
    tickTimer: () => void;
    endYear: () => void;
}

interface State
{
    month: string;
}

import './GameCalendar.scss';

// const year_length: number = 10;
const year_length: number = 120;
// const year_length: number = 60;

class GameCalendar extends React.Component<Props, State>
{
    timer: number;

    constructor(public props: Props, public state: State)
    {
        super(props);

        this.state = {
            month: MONTHS[0]
        }
    }


    componentDidMount()
    {
        this.onUpdate();
    }


    componentDidUpdate(prev_props: Props)
    {
        this.onUpdate(prev_props);
    }


    componentWillUnmount()
    {
        clearInterval(this.timer);
    }


    onUpdate = (prev_props?: Props) =>
    {
        this.toggleTimer();

        // console.log('on update', this.props, prev_props)

        // if (! prev_props) return;
        //
        // const {season:oseason} = prev_props;
        // const {season:nseason} = this.props;
        //
        // if (oseason !== nseason) this.time = 0;
    };


    toggleTimer = () =>
    {
        const {timer_is_running} = this.props;

        // console.group('toggleTimer');
        // console.log('timer_is_running', timer_is_running)
        // console.log('this.timer', this.timer)
        // console.groupEnd();

        if (timer_is_running && _.isFinite(this.timer)) return;

        if (timer_is_running)
        {
            this.timer = setInterval(this.onTimerTick, 1000) as any;
        }
        else
        {
            clearInterval(this.timer);

            this.timer = null;
        }
    };


    onTimerTick = () =>
    {
        const {time, tickTimer, duration} = this.props;

        tickTimer();

        // const {triggerSeasonalContent} = this.props;

        // if (time === Math.round(season_length * 0.5)) triggerSeasonalContent();

        const index: number = Math.floor(time / duration * 12);
        const month: string = MONTHS[index];

        this.setState({month});

        if (time < duration - 1) return;
        // if (time < year_length - 1) return;


        const {endYear} = this.props;

        endYear();
    };


    render()
    {
        const {year:year_obj, endYear, timer_is_running, time, duration} = this.props;
        const {year} = year_obj;
        const {month} = this.state;

        // if (! season) return null;

        // const {is_dragging} = this.props;

        const remaining: number = duration - time;

        return <div styleName={'container'}>

            <div
                styleName={'game-calendar'}
                onClick={endYear}>

                {/*<p>{year_obj.year}:<br />{month}<br/>{time}</p>*/}

                {/*<div styleName={'header'}>{month}</div>*/}
                <div styleName={'header'}>{remaining} seconds</div>

                <div styleName={'year'}>

                    <Calendar year={year}/>

                </div>

            </div>

            {/*{timer_is_running &&
            <p styleName={'countdown'}>{remaining}</p>}*/}

            {(timer_is_running && remaining <= 10) &&
            <div styleName={'countdown'}>{remaining}<p>seconds<br/>remaining</p></div>}

        </div>
    }
}


const mapStateToProps = state =>
{
    return {
        // season: getSeasonData(state),
        year: getYearData(state),
        time: getTime(state),
        timer_is_running: isTimerRunning(state),
        duration: getYearDuration(state),
    }
};


const mapDispatchToProps = dispatch =>
{
    return {
        tickTimer: () => dispatch(tickTimer()),
        endYear: () => dispatch(endYear()),
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(GameCalendar);



// WEBPACK FOOTER //
// ./src/ts/app/screens/game/timer/GameCalendar.tsx